/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const CreateOrUpdateFixedDepositPage = lazyLoad(
  () => import('./index'),
  module => module.CreateOrUpdateFixedDepositPage,
);
